export const Schema = () => ({
  category: 'Article',
  label: 'Dynamic Article Hero',
  key: 'dynamicArticleHero',
  fields: [
    {
      name: 'mediaVideo',
      component: 'text',
      label: 'Accompanying Video',
      description:
        'Accompanying Video will always be used in place of Accompanying Image.',
    },
    {
      label: 'Background Color',
      name: 'backgroundColor',
      component: 'select',
      options: [
        { label: 'Blue', value: 'blue' },
        { label: 'Red', value: 'red' },
      ],
      defaultValue: 'blue',
    },
    {
      name: 'mediaPlacement',
      component: 'select',
      label: 'Media Placement',
      options: [
        {
          label: 'Left',
          value: 'left',
        },
        {
          label: 'Right',
          value: 'right',
        },
      ],
      defaultValue: 'left',
    },
    {
      label: 'Center Content',
      name: 'centerContent',
      component: 'toggle',
      toggleLabels: {
        true: 'On',
        false: 'Off',
      },
      defaultValue: false,
    },
  ],
});
